<pg-home-section-1>
  <section id="home-section-1">
    <carousel-slide carouselid='hero' bullets={ false } auto-play={ 18000 } onChange={ carouselChange }>
      <section id="home-section-1-1">
        <img src={ornament1} alt="" class="ornaments home-section-1-1-ornament-1">
        <header>
          <h2>Soluções customizadas feitas para você e para o seu negócio.</h2>
        </header>
        <a class="btn" target="_blank" href="https://lp.vlgicorporate.com.br/fale-com-especialista">Clique aqui e confira!</a>
      </section>
    </carousel-slide>
  </section>

  <script>
    import './pg-home-section-1.scss'

    import CarouselSlide from '../../components/carousel-slide.riot'

    import ornament1 from '../../media/home-ornaments/home-1.svg'

    export default {
      ornament1,
      components: {
        CarouselSlide,
      },
      onBeforeMount(){
      },
      onMounted(){
        // set nav color based on sub session bg color
        this.setMainSectionStyle(0)
      },
      setMainSectionStyle (carouselIdx) {
        const selectedEl = this.$$('carousel-slide section')[carouselIdx]
        const selectedStyle = window.getComputedStyle(selectedEl)
        const mainSection = this.$('#home-section-1')
        mainSection.style.backgroundColor = selectedStyle.backgroundColor
        mainSection.style.backgroundAttachment = selectedStyle.backgroundAttachment
        mainSection.style.backgroundPositionX = selectedStyle.backgroundPositionX
        mainSection.style.backgroundPositionY = selectedStyle.backgroundPositionY
        mainSection.style.backgroundSize= selectedStyle.backgroundSize
      },
      carouselChange (idx) {
        this.setMainSectionStyle(idx)
        window.dispatchEvent(new Event('force-nav-change'))
      }
    }
  </script>
</pg-home-section-1>
